import { find } from 'lodash';

const titleRegex = /^dr$|^iii$|^inc$|^llc$|^mba$|^miss$|^mne$|^mr$|^ms$|^mrs$|^phd$|^prof$|^professor$/i;

export default (name) => {
  const uppercase = name.toLocaleUpperCase();
  const noPunc = uppercase.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '');
  /* First letter of word that isn't a title (mr, mrs, dr, etc) */
  const chunks = noPunc.split(' ');
  const firstInitial = find(chunks, chunk => !titleRegex.test(chunk));

  if (firstInitial === undefined) {
    return undefined;
  }

  return firstInitial.charAt(0);
};
